import * as Generated from './generated/AnalyticsBeacons'

// Alias the really long namespaces then re-export them in more consumable forms
// These are pretty common structs.
import Environment = Generated.Environment
import ClientParameters = Generated.ClientParameters
import LocationSource = Generated.LocationSource
import HeroCampaign = Generated.HeroCampaign
import HeroBase = Generated.HeroBase
import SourceAction = Generated.SourceAction
import ViewParameters = Generated.ViewParameters

// Beacons
import HeroPostOpenPostExperience = Generated.HeroPostOpenPostExperience
import HeroPostOpenFlyer = Generated.HeroPostOpenFlyer
import HeroPostFlyerViewFlyer = Generated.HeroPostFlyerViewFlyer
import HeroPostClosePost = Generated.HeroPostClosePost
import HeroPostFlyerClickFlyerItem = Generated.HeroPostFlyerClickFlyerItem
import HeroPostFlyerEngagedVisitFlyer = Generated.HeroPostFlyerEngagedVisitFlyer

enum Schemas {
    HeroPostOpenPostExperience = Generated.HeroPostOpenPostExperienceSchemaId,
    HeroPostOpenFlyer = Generated.HeroPostOpenFlyerSchemaId,
    HeroPostFlyerViewFlyer = Generated.HeroPostFlyerViewFlyerSchemaId,
    HeroPostFlyerEngagedVisitFlyer = Generated.HeroPostFlyerEngagedVisitFlyerSchemaId,
    HeroPostFlyerClickFlyerItem = Generated.HeroPostFlyerClickFlyerItemSchemaId,
    HeroPostClosePost = Generated.HeroPostClosePostSchemaId,
}

export {
    HeroPostOpenPostExperience,
    HeroPostOpenFlyer,
    HeroPostFlyerViewFlyer,
    HeroPostClosePost,
    HeroPostFlyerClickFlyerItem,
    HeroPostFlyerEngagedVisitFlyer,
    ClientParameters,
    LocationSource,
    Environment,
    HeroCampaign,
    HeroBase,
    SourceAction,
    ViewParameters,
    Schemas,
}
